export const PROPOSAL_LIST_REQUEST = 'PROPOSAL_LIST_REQUEST';
export const PROPOSAL_LIST_SUCCESS = 'PROPOSAL_LIST_SUCCESS';
export const PROPOSAL_LIST_FAIL = 'PROPOSAL_LIST_FAIL';
